import type { FC, ReactNode } from "react";
import type { MotionProps } from "motion/react";
import { motion } from "motion/react";

import { Flex } from "../Flex/Flex";
import { headerStyle } from "./NavigationContentHeader.css";
import { Text } from "../Text/Text";
import { Ruler } from "../Ruler/Ruler";

interface NavigationContentHeaderProps {
  title?: string;
  subtitle?: ReactNode;
  trailing?: ReactNode;
  totalSteps?: number;
  stepsFinished?: number;
  timeIndication?: number;
  variants?: MotionProps["variants"];
  variant?: "compact" | "default" | "sideContent";
}

/**
 * A header component for the navigation content.
 */
export const NavigationContentHeader: FC<NavigationContentHeaderProps> = ({
  title,
  subtitle,
  trailing,
  variant = "default",
}) => (
  <motion.header className={headerStyle({ variant })}>
    <Flex gap="xxs" justify="center" grow>
      <Flex direction="column" gap="xxs2" grow justify="center">
        <Text variant="bodyL">{title}</Text>
        {subtitle}

        {/* {timeIndication !== undefined && !!totalSteps && totalSteps > 0 && (
            <Flex className={timeIndicationStyle} align="center">
              {timeIndication !== undefined && timeIndication > 0 && (
                <>
                  <TimeChip indication={timeIndication} variant="displayM" />
                  <Text
                    variant="bodyL"
                    color="currentColor50"
                    bold
                    className={dotStyle}
                  >
                    ·
                  </Text>
                </>
              )}
              <Text variant="bodyS" color="currentColor50">
                <I18n
                  id="general.stepsIndication"
                  replacers={{
                    current: stepsFinished ?? 0,
                    total: totalSteps ?? 0,
                    label: getPluralOrSingularTranslation(
                      totalSteps ?? 0,
                      i18n("general.steps.singular"),
                      i18n("general.steps.plural"),
                    ),
                  }}
                />
              </Text>
            </Flex>
          )} */}
      </Flex>

      {trailing}
    </Flex>
    <Ruler />
  </motion.header>
);
